import { TEditConfigurationGeneralItem, TProjectConfigurationGeneralItem } from 'pages/common/types';

export const getGeneralItemsForPatch = (
  items: TProjectConfigurationGeneralItem[]
): TEditConfigurationGeneralItem[] =>
  items.map((item, index) => ({
    ...item,
    itemId: String(index + 1),
  }));
